// Small helpers shared by the primitives.
export const cx = (...parts) => parts.filter(Boolean).join(' ');

